import { Flex } from 'antd';
import { Outlet } from 'react-router-dom';
import styles from './ai-agents.module.scss';

export const AiAgents = () => (
  <Flex className={styles.root}>
    <Outlet />
  </Flex>
);
